import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { EventModel } from 'API/Generated/data-contracts';
import { useHistory } from 'react-router-dom';
import { GetPageantStore } from 'SessionState/Pageant/PageantStore';
import ImageRender from 'views/components/ImageRender';
import { sanitizeForURL } from 'helpers/Helpers';
import { formatDateJustMonthAndYear, formatDateMonthsAbrevWithDay, formatDateRange } from 'helpers/DateHelper';

interface Props {
  eventModel: EventModel;
}

interface EventMetadata {
  ogImage: string;
  ogTitle: string;
  ogDescription: string;
}


const EventIconCard = observer(({ eventModel }: Props) => {
  const history = useHistory();
  const pageantStore = GetPageantStore();
  const containerName = 'event-cover-photos';
  const claimThisEventImage = 'ClaimThisEvent.png';
  const location = useLocation<{ metadata?: EventMetadata }>();
  const { metadata } = location.state || {};
  const [ogMetadata, setOgMetadata] = useState<EventMetadata | null>(metadata || null);
  const [loading, setLoading] = useState(false);
  // Determine the event type dynamically (assuming `eventModel.type` holds the type)
  const eventType = 'pageant';  // You can adjust this based on how your event type is stored

  const modifiedEventName = sanitizeForURL(eventModel?.name);

  const navigateToEventDetail = async () => {
    pageantStore.resetCurrentPageant();
    setLoading(true);
    setOgMetadata(metadata);
    console.log('Fetched Metadata from event card:', metadata);  // Log the fetched metadata
    if (eventModel.pageantId && metadata) {
      const modifiedEventName = sanitizeForURL(eventModel?.name);
      history.push({
        pathname: `/events/${eventType}/${eventModel.pageantId}/${modifiedEventName}/details`,
        state: { metadata }
      });
    }
    setLoading(false);
    console.log("Event Card", eventModel.id, eventModel?.pageant?.id, modifiedEventName);
  };

  // Facebook share URL
  const eventUrl = `https://hellotiara.com/events/${eventType}/${eventModel.pageantId}/${modifiedEventName}/details`;
 
  return (
    <>
      {/* Event Icon Card Start */}
        <Link to={`/events/${eventType}/${eventModel.pageantId}/${modifiedEventName}/details`} onClick={navigateToEventDetail} className="text-center text-small text-body">
          <span className='text-center justify-content-center align-content-center'>
          {eventModel?.directorMembership == "Unclaimed" && eventModel?.coverPhoto?.image === '' ? (
              <ImageRender src={claimThisEventImage} containerName={'hello-tiara'} alt={eventModel?.name || 'Event Photo'} className="profile rounded-circle sh-8 sw-8 m-auto mb-2" />
            ) : (
              <ImageRender src={eventModel.coverPhoto?.image} containerName={containerName} alt={eventModel?.name || 'Event Photo'} className="profile rounded-circle sh-8 sw-8 m-auto mb-2" />
            )}
          {/* <ImageRender src={eventModel.coverPhoto?.image} containerName={containerName}   alt={eventModel?.name || 'Event Photo'} className="profile rounded-circle sh-8 sw-8 m-auto mb-2" />  */}
          </span>
          {/* Event Details Start */}
            <span className="fw-bold mb-0 text-center d-block cardHeading">
              {eventModel.name}
            </span>
             <span className="mb-0 text-center d-block">
              {formatDateJustMonthAndYear(eventModel.startDate)}
            </span>
          {/* Event Details End */}
        </Link>
      {/* Event Icon Card End */}
    </>
  );
});

export default EventIconCard;
